import ContentHeader from '@Components/ContentHeader'
import './index.scss'
import React from 'react'

const NewUserHeader = () => (
    <div className="new-user-scene-header">
        <ContentHeader
            title="Welcome! Let’s Customize Your Experience"
            descriptionElement={
                <p>
                    To help us guide you to the right Hub, please select the role that best describes you. Selecting the
                    right option ensures you get the most out of your experience.
                </p>
            }
        />
    </div>
)
export default NewUserHeader
